import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle2 } from 'lucide-react';

const Gracias = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Get form data from localStorage
    const savedData = localStorage.getItem('saori_reservation');
    if (savedData) {
      setUserData(JSON.parse(savedData));
    }

    // Trigger Meta Pixel Lead event
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  }, []);

  const handleWhatsAppClick = () => {
    const whatsappNumber = '5491163585211';
    const nombre = userData?.nombre || 'Cliente';
    const message = encodeURIComponent(`¡Hola SAORI! ✨ Vengo de la web y quiero consultar por un vestido para mi evento. Mi nombre es ${nombre}.`);
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <div className="gracias-container">
      <div className="gracias-content">
        <div className="gracias-icon">
          <CheckCircle2 className="success-icon" />
        </div>
        
        <h1 className="gracias-title">
          ¡Cita solicitada con éxito, {userData?.nombre || 'hermosa'}! ✨
        </h1>
        
        <p className="gracias-message">
          Una asesora de SAORI te contactará por WhatsApp en breve para confirmar tu horario y asegurar tu beneficio de Marzo. ¡Estamos ansiosas por ayudarte a brillar!
        </p>

        <div className="gracias-actions">
          <Button 
            onClick={handleWhatsAppClick}
            className="gracias-whatsapp-button"
            size="lg"
          >
            Escribinos ahora por WhatsApp
          </Button>
          
          <Button 
            onClick={() => navigate('/')}
            variant="outline"
            className="gracias-back-button"
          >
            Volver al inicio
          </Button>
        </div>

        <div className="gracias-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_2ad91963-089e-4db0-b314-e1367663a960/artifacts/ccgaqtts_saori%20sin%20fondo.png" 
            alt="SAORI" 
            className="logo-gracias"
          />
        </div>
      </div>
    </div>
  );
};

export default Gracias;
